import { Link, useLocation } from '@tanstack/react-router'
import { CompassIcon } from 'lucide-react'

import { SidebarItem } from '@/components'
import { useShowGettingStartedNudges } from '../hooks'

// The sidebar nudge. Hidden once the account has done the work or the user
// dismissed it; the page stays reachable from Get help.
export function GettingStartedNavItem() {
  const location = useLocation()
  const show = useShowGettingStartedNudges()

  if (!show) return null

  return (
    <SidebarItem
      asChild
      active={location.pathname.startsWith('/getting-started')}
      icon={CompassIcon}
    >
      <Link to="/getting-started" preload="intent">
        Getting started
      </Link>
    </SidebarItem>
  )
}
